import {MaterialDesignContent, SnackbarProvider} from 'notistack';
import {styled} from '@mui/styles';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorIcon from '@mui/icons-material/Error';
import {AgyleInfoFilledIcon, AgyleWarningIcon} from '../icons/agyle';
import makeStyles from '@mui/styles/makeStyles';
import config from '../../app/config';

export const SNACKBAR_COLORS = {
    success: {
        background: '#c9e7d4',
        color: '#2e6441',
    },
    error: {
        background: '#f4c3c6',
        color: '#70191c',
    },
    warning: {
        background: '#fee4b1',
        color: '#7f4501',
    },
    info: {
        background: '#dee1e5',
        color: '#313233',
    },
};

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent': {
        borderRadius: 8,
        padding: '5px 15px 5px 39px',
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'flex-start',
        gap: 10,
        position: 'relative',
    },
    '&.notistack-MuiContent-success': {
        backgroundColor: SNACKBAR_COLORS.success.background,
        border: `2px solid ${SNACKBAR_COLORS.success.color}`,
        color: SNACKBAR_COLORS.success.color,
    },
    '&.notistack-MuiContent-error': {
        backgroundColor: SNACKBAR_COLORS.error.background,
        border: `2px solid ${SNACKBAR_COLORS.error.color}`,
        color: SNACKBAR_COLORS.error.color,
    },
    '&.notistack-MuiContent-warning': {
        backgroundColor: SNACKBAR_COLORS.warning.background,
        border: `2px solid ${SNACKBAR_COLORS.warning.color}`,
        color: SNACKBAR_COLORS.warning.color,
    },
    '&.notistack-MuiContent-info': {
        backgroundColor: SNACKBAR_COLORS.info.background,
        border: `2px solid ${SNACKBAR_COLORS.info.color}`,
        color: SNACKBAR_COLORS.info.color,
    },
}));

const useStyles = makeStyles((theme) => ({
    icon: {
        position: 'absolute',
        top: 11,
        left: 8,
    },
    snackbar: {
        '& #notistack-snackbar': {
            maxWidth: 578,
            gap: 5,
        },
    },
}));

const SystemSnackbarProvider = (props) => {
    const classes = useStyles();
    const hideDuration = config?.modules?.alerts?.defaultDuration || 5000;

    return (
        <SnackbarProvider
            maxSnack={3}
            autoHideDuration={hideDuration}
            Components={{
                success: StyledMaterialDesignContent,
                error: StyledMaterialDesignContent,
                warning: StyledMaterialDesignContent,
                info: StyledMaterialDesignContent,
            }}
            iconVariant={{
                success: <CheckCircleRoundedIcon className={classes.icon}/>,
                error: <ErrorIcon className={classes.icon}/>,
                warning: <AgyleWarningIcon className={classes.icon}/>,
                info: <AgyleInfoFilledIcon className={classes.icon}/>,
            }}
            preventDuplicate
            className={classes.snackbar}
        >
            {props.children}
        </SnackbarProvider>
    );
};

export default SystemSnackbarProvider;